export const initialise = () => {
    if (!document.body.classList.contains('page-post-results')) return
    const filters = document.querySelectorAll<HTMLDivElement>('.content-types-widget, .attrax-post-filters')

    filtersContainer()
    filterHeading(filters)
    filterMenu(filters)
}

const filtersContainer = () => {
    const container = document.querySelector('.layout-post__container-filters')
    const filtersContainer = document.querySelector<HTMLDivElement>('.layout-post__container-filters .container-col')
    const filtersContainerContent = document.querySelector('.layout-post__container-filters-content')
    const filtersButton = document.querySelector('.layout-post__button-filter')
    if (!container || !filtersContainer || !filtersContainerContent || !filtersButton)
        {
            console.log('Post filters container elements not found, skipping filters container setup.')
            return
        }

    
    const linkClear: HTMLAnchorElement = document.createElement('a')
    linkClear.className = 'layout-post__link-filters-clear'
    linkClear.innerHTML = '{{js.layout.posts.filters.link.clear.text}}'
    linkClear.ariaLabel = '{{js.layout.posts.filters.link.clear.aria-label}}'
    linkClear.href = '{{js.layout.posts.filters.link.clear.href}}'

    filtersButton.setAttribute('aria-expanded', 'true')
    filtersContainerContent.setAttribute('aria-hidden', 'false')

    filtersButton.addEventListener('click', () => {
        console.log('Toggling filters container visibility')
        const isExpanded: boolean = container.classList.toggle('layout-post__container-filters--visible')
        filtersButton.setAttribute('aria-expanded', isExpanded.toString())
        filtersContainerContent.setAttribute('aria-hidden', (!isExpanded).toString())
        filtersContainerContent.toggleAttribute('inert', (!isExpanded))
    })
}

const filterHeading = (filters: NodeListOf<HTMLElement>) => {
    filters.forEach((filter: HTMLElement) => {
        const header = filter.querySelector<HTMLElement>('.content-types-widget__heading, .attrax-post-filters__heading')
        if (!header) return

        const button: HTMLButtonElement = document.createElement('button')
        button.className = header.className
        button.innerHTML = header.innerHTML
        header.replaceWith(button)

        const container = filter.querySelector<HTMLElement>('.attrax-post-filters__heading-container')
        if (!container) return
        container.replaceWith(button)
    })
}

const filterMenuClose = (filter: HTMLDivElement, button: HTMLButtonElement, list: HTMLUListElement) => {
    filter.classList.remove('opened')
    button.setAttribute('aria-expanded', 'false')
    list.setAttribute('aria-hidden', 'true')
    list.toggleAttribute('inert', true)
}

const filterMenu = (filters: NodeListOf<HTMLDivElement>) => {
    filters.forEach((filter: HTMLDivElement) => {
        const button = filter.querySelector<HTMLButtonElement>('.content-types-widget__heading, .attrax-post-filters__heading')
        const menu = filter.querySelector<HTMLUListElement>('ul, .attrax-post-filters__list')
        if (!button || !menu) return

        button.setAttribute('aria-expanded', 'false')
        menu.setAttribute('aria-hidden', 'true')
        menu.setAttribute('inert', 'true')

        let outsideClickHandler: ((event: MouseEvent) => void) | null = null

        const closeFilter = () => {
            filterMenuClose(filter, button, menu)
            if (outsideClickHandler) {
                document.removeEventListener('click', outsideClickHandler)
                outsideClickHandler = null
            }
        }

        const toggleFilter = () => {
            const isExpanded: boolean = filter.classList.toggle('opened')
            button.setAttribute('aria-expanded', isExpanded.toString())
            menu.setAttribute('aria-hidden', (!isExpanded).toString())
            menu.toggleAttribute('inert', !isExpanded)
            
            if (isExpanded) {
                outsideClickHandler = (event: MouseEvent) => {
                    if (!filter.contains(event.target as Node)) {
                        closeFilter()
                    }
                }
                document.addEventListener('click', outsideClickHandler)
            } else if (outsideClickHandler) {
                document.removeEventListener('click', outsideClickHandler)
                outsideClickHandler = null
            }
        }

        const observer = new MutationObserver(() => {
            if (!filter.classList.contains('opened') && outsideClickHandler) {
                document.removeEventListener('click', outsideClickHandler)
                outsideClickHandler = null
            }
        })
        observer.observe(filter, { attributes: true, attributeFilter: ['class'] })

                button.addEventListener('click', () => {
            toggleFilter()
        })
        
        button.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                toggleFilter()
            }
        })
        
        filter.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                button.focus()
                closeFilter()
            }
        })
        
        filter.addEventListener('focusout', (event: FocusEvent) => {
            if (event.relatedTarget && !filter.contains(event.relatedTarget as Node)) {
                closeFilter()
            }
        })

        const intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (filter.classList.contains('opened') && !entry.isIntersecting) {
                    closeFilter()
                }
            })
        }, { threshold: 0 })
        intersectionObserver.observe(filter)
    })
}